import React from 'react'
import USTemplateDefault from 'src/components/template/us'
export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/AdobeStock_210894329.jpg?w=2048&ch=width&auto=format,compress"
    title="Watch TyC Sports Live"
    subtitle="Stream on your phone, TV and more"
    networkSet="sports"
    customNetworks={['tyc']}
  />
)
